import { render, staticRenderFns } from "./OrderCloneButton.vue?vue&type=template&id=beeed26e&scoped=true"
import script from "./OrderCloneButton.vue?vue&type=script&lang=js"
export * from "./OrderCloneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeed26e",
  null
  
)

export default component.exports